import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextBrackets20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTextBrackets20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 5.745a2.75 2.75 0 0 1 2.75-2.75h1.6a.75.75 0 0 1 0 1.5h-1.6c-.69 0-1.25.56-1.25 1.25v8.513c0 .69.56 1.25 1.25 1.25h1.6a.75.75 0 0 1 0 1.5h-1.6A2.75 2.75 0 0 1 1 14.258zm18 .005A2.75 2.75 0 0 0 16.25 3h-1.6a.75.75 0 0 0 0 1.5h1.6c.69 0 1.25.56 1.25 1.25v8.514c0 .69-.56 1.25-1.25 1.25h-1.6a.75.75 0 0 0 0 1.5h1.6a2.75 2.75 0 0 0 2.75-2.75zM6.4 6.5a.75.75 0 1 0 0 1.5h7.2a.75.75 0 1 0 0-1.5zm-.75 3.75a.75.75 0 0 1 .75-.75h7.2a.75.75 0 1 1 0 1.5H6.4a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 1 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextBrackets20);
